import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, TextField } from "@mui/material";
import { useTableDispenserUserConfig } from "./hooks";
import { getDriverUser } from "../../redux/actions/dispenserUser/dispenserUserAction";
import { orderArrayV2 } from "../../helpers/orderArray";

export const DispenserUserSelectUnit = (props) => {
  const { size = 'small' } = props;
  const { handleChangeUnit, handleChangeUnitOptions } = useTableDispenserUserConfig();
  const dispatch = useDispatch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { unitsMap } = useSelector(({ unitsReducer }) => unitsReducer);
  const { station, unit, unitOptions, dispenserUserSelected } = useSelector(({ dispenserUser }) => dispenserUser);
  
  useEffect(() => {
    if(station?.id) {
      const units = unitsMap.filter(unit => unit.idStation === station?.id && unit.type === "ESTACION");
      handleChangeUnitOptions(units);
    } else handleChangeUnitOptions([]);
    // eslint-disable-next-line 
  }, [station?.id]);

  useEffect(() => {
    if(unit?.id && !isLoadingComp?.loadingDriverUser && !unit?.driverUser?.search) dispatch(getDriverUser(unit));
    // eslint-disable-next-line 
  }, [unit]);
  
  return (
    <Autocomplete
      id="combo-box-demo"
      options={orderArrayV2(unitOptions)}
      value={unit}
      filterSelectedOptions
      disabled={dispenserUserSelected?.id}
      getOptionLabel={(option) => option.label ? option.label : option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          name="unit"
          label="Unidad"
          variant="outlined"
          disabled={dispenserUserSelected?.id}
          size={size}
        />
      )}
      fullWidth
      onChange={(e, v) => handleChangeUnit(e, v)}
      noOptionsText="No se encuentran unidades de tipo estación"
    />
  );
};
